import moment from 'moment';

export const formatDate = (date: string): string =>
  moment(date).format('DD/MM/YYYY');

export const capitalize = (s: string) => {
  return s.charAt(0).toUpperCase() + s.slice(1);
};
